import React from "react";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  MenuItem,
  MenuList,
  styled,
  Switch,
  Tooltip,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useReferences } from "../Guid/Hooks/Refrences";
import { Link, useLocation } from "react-router-dom";
import imag from "../assets/IZO.jpg";

const downloadResume = () => {
  // using Java Script method to get PDF file
  fetch("CVEnglishTeraByte.pdf").then((response) => {
    response.blob().then((blob) => {
      // Creating new object of PDF file
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = "Resume Azlarab Oujdad.pdf";
      alink.click();
    });
  });
};

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

function SideBar({
  mode,
  setMode,
}: {
  mode: boolean;
  setMode: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { menuItems, guiderMenuItem } = useReferences();

  const location = useLocation();

  return (
    <Box sx={{ flexGrow: 1, width: "100%", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          color: "info.main",
        }}
      >
        <Typography>{`${mode ? "Light" : "Dark"} mode`}</Typography>
        <MaterialUISwitch
          checked={mode}
          onChange={(e) => setMode(e?.target?.checked)}
        />
      </Box>
      <Grid container spacing={2} height="100vh">
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              marginBottom: "5%",
              marginLeft: "2%",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar
              alt="RProfileImage"
              src={imag}
              sx={{
                width: 100,
                height: 100,
                borderStyle: "solid",
                borderWidth: "5px",
                marginRight: "0%",
                borderColor: "primary.main",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "3%",
            }}
          >
            <Typography
              fontSize="2rem"
              sx={{ textAlign: "center", color: "info.main" }}
            >
              Azlarab Oujdad
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Tooltip title="Go to linkedIn">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                onClick={() => {
                  window.location.replace(
                    "https://www.linkedin.com/in/azelarab-oujdad/"
                  );
                }}
              >
                <LinkedInIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download CV">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                onClick={() => {
                  downloadResume();
                }}
              >
                <PictureAsPdfIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MenuList sx={{ borderStyle: "none" }}>
            {menuItems.map((item) => (
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={item.link}
              >
                <MenuItem
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    color:
                      location.pathname === item.link
                        ? "primary.main"
                        : "info.main",
                    backgroundColor:
                      guiderMenuItem === item.label
                        ? "background.paper"
                        : "transparent",
                    fontSize: "2rem",
                  }}
                >
                  {item.label}
                </MenuItem>
              </Link>
            ))}
          </MenuList>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SideBar;
